import * as React from "react";

import { Card, Elevation, Intent, ProgressBar } from "@blueprintjs/core";
import { css } from "glamor";

import { FightOverview } from "src/Interfaces";
import { getActiveFights } from "../api";
import { partsFight3Stages, partsFight4Stages, phasesForTimer } from "../constants";

import Loading from "../Loading";

const styles = {
	container: css({
		display: "flex",
		flexWrap: "wrap",
	}),
	element: css({
		minWidth: "300px",
		margin: "20px",
		textAlign: "left",
	}),
	title: css({
		fontSize: "24px",
		margin: "20px",
	}),
	infoPiece: css({
		fontSize: "18px",
		margin: "10px 20px",
	}),
	progressBarPiece: css({
		display: "flex",
	}),
	progressBar: css({
		padding: "10px",
		flexGrow: 1,
		minWidht: "100px",
	}),
	flexGrow: css({ flexGrow: 1 }),
};

interface Props {
	dark: boolean;
}

const makeProgressBars = (fight: FightOverview) => {
	if (fight.nrOfStages === 4) {
		return (
			<div {...styles.progressBarPiece}>
				{makeProgressBar(getStageProgress(1, fight))}
				{makeProgressBar(getStageProgress(2, fight))}
				{makeProgressBar(getStageProgress(3, fight))}
				{makeProgressBar(getStageProgress(4, fight))}
			</div>
		);
	} else {
		return (
			<div {...styles.progressBarPiece}>
				{makeProgressBar(getStageProgress(1, fight))}
				{makeProgressBar(getStageProgress(2, fight))}
				{makeProgressBar(getStageProgress(3, fight))}
			</div>
		);
	}
};

const makeProgressBar = (value: number) => (
	<div {...styles.progressBar}>
		<ProgressBar
			animate={false}
			stripes={false}
			value={value}
			intent={value === 1 ? Intent.SUCCESS : Intent.PRIMARY}
		/>
	</div>
);

const getStageProgress = (stage: number, fight: FightOverview) => {
	if (fight.currentpart >= 2 * stage) {
		return 1;
	} else if (fight.currentpart !== 2 * stage - 1) {
		return 0;
	} else {
		return fight.currentphase / phasesForTimer.length;
	}
};
export default class LiveOverviewContent extends React.Component<
	Props,
	{ fights: FightOverview[] }
> {
	private interval: any = null;
	public state = { fights: [] as FightOverview[] };
	public async componentDidMount() {
		const fights = await getActiveFights();
		this.setState({ fights });
		this.interval = setInterval(async () => {
			const newFights = await getActiveFights();
			this.setState({ fights: newFights });
		}, 2000);
	}
	public componentWillUnmount() {
		clearInterval(this.interval);
	}

	private makeOverview = () => (
		<div {...styles.container}>
			{([] as any[])
				.concat(this.state.fights)
				.sort((a, b) => (a.name < b.name ? -1 : 1))
				.map((fight: any) => {
					let part = partsFight3Stages[fight.currentpart];
					if (fight.nrOfStages === 4) {
						part = partsFight4Stages[fight.currentpart];
					}
					return (
						<div key={fight.id} {...styles.flexGrow}>
							<Card {...styles.element} interactive={false} elevation={Elevation.TWO}>
								<div {...styles.title}>{fight.name}</div>
								<div {...styles.infoPiece}>{part.name}</div>
								{part.type === "stage" ? (
									<div {...styles.infoPiece}>{phasesForTimer[fight.currentphase].name}</div>
								) : (
									<div>
										<br />
									</div>
								)}
								<div>{makeProgressBars(fight)}</div>
							</Card>
						</div>
					);
				})}
		</div>
	);
	public render() {
		return <div>{this.state.fights.length >= 1 ? this.makeOverview() : <Loading />}</div>;
	}
}



// WEBPACK FOOTER //
// ./src/Backend/LiveOverviewContent.tsx